module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tip-row-men-header">\n	<div class="logo">\n		<img src="/assets/images/nrl-shield-logo-on-light.svg" alt="NRL Premiership Logo">\n	</div>\n	<span>\n		NRL MENS '+
((__t=( final_name.toUpperCase() ))==null?'':_.escape(__t))+
'\n	</span>\n</div>\n\n<div class="tip-row tbs">\n	<div class="squad home-squad tbc-home">\n		<label class="checkbox">'+
((__t=( home_squad_name ))==null?'':_.escape(__t))+
'</label>\n\n	</div>\n	<div class="squad away-squad tbc-away">\n		<label class="checkbox">'+
((__t=( away_squad_name ))==null?'':_.escape(__t))+
'</label>\n	</div>\n</div>\n\n';
}
return __p;
};
